import { Col, Row } from 'react-grid-system';
import styled from 'styled-components';
import { useUserLanguage } from '@/customHooks';
import textsData from '@/textData/CreateCommunicationsTexts.json';
import {
  CommunicationConfirmationDialog,
  SelectCommunicationAudience,
  ComposeCommunicationMessage,
} from '../organism';

type CreateCommunicationTemplateProps = {
  currentTemplate: number;
};

const TextContainer = styled(Col)`
  text-align: center;
  margin-bottom: 3rem;
  h1 {
    font-size: 2rem;
    font-weight: 700;
  }
`;

export const CreateCommunicationTemplate = ({
  currentTemplate,
}: CreateCommunicationTemplateProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;

  return (
    <>
      <Row>
        <TextContainer>
          <h1>{texts.templateText[currentTemplate].title}</h1>
          <p>{texts.templateText[currentTemplate].description}</p>
        </TextContainer>
      </Row>
      {(() => {
        switch (currentTemplate) {
          case 0:
            return <SelectCommunicationAudience />;
          case 1:
            return <ComposeCommunicationMessage />;
          case 2:
            return <CommunicationConfirmationDialog />;
          default:
            throw new Error('Invalid currentTemplate [CreateCommunicationTemplate]');
        }
      })()}
    </>
  );
};

